import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function ColectieCurriculum() {
  const courses = [{
    number: '01',
    title: 'Magnet pentru Bani',
    image: 'https://cdn.magicpatterns.com/uploads/oxDzSULSMwG2nL85tGVmvD/magnet_pentru_bani.png',
    bullets: ['Vei înțelege ce sunt banii cu adevărat și vei dezlega misterul relației tale cu ei', 'Vei identifica și elibera convingerile din subconștient care te sabotează financiar', 'Vei învăța cum să îți binecuvântezi banii, să îi înmulțești și să devii un magnet care îi atrage']
  }, {
    number: '02',
    title: 'Deschide-ți Larg Brațele către Abundență',
    image: 'https://cdn.magicpatterns.com/uploads/2YRYCupB7btTBZWvCbbPCx/deschide_ti_larg_bratele.png',
    bullets: ['Vei descoperi că abundența nu e doar despre bani, ci despre a avea ceea ce îți dorești din plin în toate ariile vieții', 'Vei învăța o meditație care îți aduce instant pacea minții și unelte practice pe care le aplici zilnic', 'Vei primi tehnici testate care aduc rezultate reale, inclusiv "propoziția win-win" pentru atragerea oportunităților']
  }, {
    number: '03',
    title: 'ABC-ul Prosperității',
    image: 'https://cdn.magicpatterns.com/uploads/oZksrSnCWfk8LyDXsh6Pco/abc_prosperitatii.png',
    bullets: ['Vei descoperi sensul adevăratei bogății și vei identifica gândurile limitative care te țin departe de ea', 'Vei învăța cum să te eliberezi de vechile convingeri și să îți creezi afirmații care lucrează pentru tine', 'Vei construi propria hartă a comorilor care să te ghideze către cea mai bună versiune a vieții tale']
  }, {
    number: '04',
    title: 'Abundența Iubirii',
    image: 'https://cdn.magicpatterns.com/uploads/n8bKcew6bBtWyTffgJ5cSo/abundenta_iubirii.png',
    bullets: ['Vei descoperi tipurile de iubire și vei învăța cum să te iubești pe tine cu adevărat, prin exercițiul oglinzii și cercul iubirii', 'Vei practica exerciții de eliberare a resentimentelor, iertare și reconectare prin iubire', 'Vei experimenta meditații ghidate pentru creșterea vibrației energetice și iubirea de sine']
  }, {
    number: '05',
    title: 'Arta de a Trăi o Viață Fără Stres',
    image: 'https://cdn.magicpatterns.com/uploads/9sdvN9bcvMgf498WmqzmgR/arta_de_a_trai_fara_stres.png',
    bullets: ['Vei învăța să îți calmezi mintea în momentele tensionate și să folosești tehnici simple de respirație și reglare emoțională', 'Vei crea obiceiuri care îți susțin liniștea și energia în fiecare zi', 'Vei descoperi cum să te eliberezi de stres și să te bucuri de viață fără să te pui mereu pe ultimul loc']
  }, {
    number: '06',
    title: 'Trăiește în Prezent și Împlinește-ți Visul',
    image: 'https://cdn.magicpatterns.com/uploads/8RhhUjnvL2TWESFtEq1HF6/elibereaza_te_de_blocaje.png',
    bullets: ['Vei învăța cum să practici cele 7 legi spirituale ale succesului pentru a-ți transforma viața', 'Vei descoperi conceptul de conștiință a bogăției pentru a obține prosperitate în mod natural', 'Vei practica exerciții concrete pentru o sănătate mai bună și vei experimenta recunoștința și iubirea în viața ta']
  }];
  return <section className="py-20 lg:py-32 bg-brand-cream relative" data-id="element-392">
      <div className="max-w-7xl mx-auto px-6" data-id="element-393">
        <SectionHeading title="Ce vei descoperi în cele 6 cursuri înregistrate ale Academiei de Abundență" data-id="element-394" />

        <div className="space-y-8 lg:space-y-10 mb-16" data-id="element-395">
          {courses.map((course, index) => {
          const isReversed = index % 2 === 1;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.7
          }} className="relative bg-white rounded-[32px] border border-brand-text/10 shadow-warm p-6 md:p-8 lg:p-10 overflow-hidden" data-id="element-396">
                <div className={`grid lg:grid-cols-2 gap-8 lg:gap-12 items-center ${isReversed ? 'lg:[direction:rtl]' : ''}`} data-id="element-397">
                  {/* Image */}
                  <div className="relative w-full max-w-[520px] mx-auto lg:max-w-none lg:[direction:ltr]" data-id="element-398">
                    <div className="relative aspect-[4/3] rounded-[20px] overflow-hidden shadow-sm" data-id="element-399">
                      <img src={course.image} alt={course.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-400" />
                      <div className="absolute top-4 left-4 bg-brand-gold text-white font-heading font-bold text-lg w-14 h-14 rounded-full flex items-center justify-center shadow-warm" data-id="element-401">
                        {course.number}
                      </div>
                    </div>
                  </div>

                  {/* Text */}
                  <div className="lg:[direction:ltr]" data-id="element-402">
                    <span className="block text-brand-gold font-subtitle italic text-lg mb-2" data-id="element-403">
                      Cursul {course.number}
                    </span>
                    <h3 className="font-heading font-bold text-2xl md:text-3xl lg:text-[34px] leading-tight text-brand-text mb-6 text-balance" data-id="element-404">
                      {course.title}
                    </h3>
                    <ul className="space-y-4" data-id="element-405">
                      {course.bullets.map((bullet, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-406">
                          <CheckCircle2 className="w-5 h-5 text-brand-gold mt-1 flex-shrink-0" data-id="element-407" />
                          <span className="text-brand-text/80 leading-relaxed text-lg" data-id="element-408">
                            {bullet}
                          </span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-409">
          <CTAButton data-id="element-410" />
        </motion.div>
      </div>
    </section>;
}